import { api, apiFile } from "api/api";
import { AxiosError } from "axios";
import Usuario from "model/administracao/cadastro/Usuario";
import DocumentoVersao from "model/documentos/DocumentoVersao";
import DocumentoVersaoLocal from "model/documentos/DocumentoVersaoLocal";
import CriarDocumentoOnline from "model/documentos/fluxo/CriarDocumentoOnline";
import DocumentoFluxo from "model/documentos/fluxo/DocumentoFluxo";
import FinalizarAprovacao from "model/documentos/fluxo/FinalizarAprovacao";
import FinalizarElaboracao from "model/documentos/fluxo/FinalizarElaboracao";
import FinalizarRevisao from "model/documentos/fluxo/FinalizarRevisao";
import PublicarVersao from "model/documentos/fluxo/PublicarVersao";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import Local from "model/patrimonio/Local";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class DocumentoVersaoService implements BaseServiceCadastros<DocumentoVersao> {

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/documentoVersao/minhasPendencias`;
            if (filters) {
                url += getFilters(filters)
            }
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };
            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
    minhasConfirmacoesLeitura(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/documentoVersao/minhasConfirmacoesLeitura`;
            if (filters) {
                url += getFilters(filters)
            }
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };
            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
    consultar(id: number) {
        return new Promise<DocumentoVersao>((resolve, reject): void => {
            api
                .get(`/documentoVersao/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
    incluir(documentoVersao: DocumentoVersao) {
        return new Promise<DocumentoVersao>((resolve, reject): void => {
            resolve(new DocumentoVersao())
        });
    }
    editar(documentoVersao: DocumentoVersao) {
        return new Promise<DocumentoVersao>((resolve, reject): void => {
            resolve(new DocumentoVersao())
        });
    }
    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            resolve();
        });
    }

    getDadosFluxo(id: number | string) {
        return new Promise<DocumentoFluxo>((resolve, reject): void => {
            api
                .get(`/documentoVersao/dadosFluxo/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }


    locais() {
        return new Promise<Local[]>((resolve, reject): void => {
            api
                .get(`/documentoVersao/locais`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    usuarios() {
        return new Promise<Usuario[]>((resolve, reject): void => {
            api
                .get(`/documentoVersao/usuarios`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    temConfirmacaoLeitura(id: number) {
        return new Promise<Boolean>((resolve, reject): void => {
            api
                .get(`/documentoVersao/temConfirmacaoLeitura/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    statusesFilter() {
        return [
            { label: 'Em Elaboração', value: 'EE' },
            { label: 'Em Revisão', value: 'ER' },
            { label: 'Aguardando Aprovação', value: 'AA' },
            { label: 'Aguardando Publicação', value: 'AP' },
            { label: 'Publicado', value: 'P' },
        ]
    }

    statuses() {
        return [
            { label: 'Em Elaboração', value: 'EM_ELABORACAO' },
            { label: 'Em Revisão', value: 'EM_REVISAO' },
            { label: 'Aguardando Aprovação', value: 'AGUARDANDO_APROVACAO' },
            { label: 'Aguardando Publicação', value: 'AGUARDANDO_PUBLICACAO' },
            { label: 'Publicado', value: 'PUBLICADO' },
        ]
    }

    getStatus(status: string): string {
        return this.statuses().find((s) => s.value === status)?.label || ''
    }

    criarDocumentoOnline(dados: CriarDocumentoOnline) {
        return new Promise<string>((resolve, reject): void => {
            let url = `/documentoVersao/criarDocumentoOnline`;
            api
                .post(url, dados)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    carregarDocumentoOnline(dados: { idVersao: number; arquivo: File; }) {
        return new Promise<string>((resolve, reject): void => {
            let url = `/documentoVersao/carregarDocumentoOnline`;
            let formData = new FormData();
            formData.append("idVersao", dados.idVersao.toString());
            formData.append("arquivo", dados.arquivo);
            apiFile
                .post(url, dados)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    deletarDocumentoOnline(idVersao: number) {
        return new Promise<void>((resolve, reject): void => {
            let url = `/documentoVersao/deletarDocumentoOnline/${idVersao}`;
            api
                .delete(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluirDistribuicao(documentoVersaoLocal: DocumentoVersaoLocal) {
        return new Promise<DocumentoVersaoLocal>((resolve, reject): void => {
            let url = `/documentoVersao/incluirDistribuicao`;
            api
                .post(url, JSON.stringify(documentoVersaoLocal))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editarDistribuicao(documentoVersaoLocal: DocumentoVersaoLocal) {
        return new Promise<DocumentoVersaoLocal>((resolve, reject): void => {
            api
                .put(`/documentoVersao/editarDistribuicao`, JSON.stringify(documentoVersaoLocal))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    reterDistribuicao(id: number) {
        return new Promise<DocumentoVersaoLocal>((resolve, reject): void => {
            api
                .put(`/documentoVersao/reterDistribuicao/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        })
    }

    finalizarElaboracao(data: FormData) {
        return new Promise<DocumentoVersao>((resolve, reject): void => {
            apiFile
                .post(`/documentoVersao/finalizarElaboracao`, data)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    finalizarRevisao(data: FormData) {
        return new Promise<DocumentoVersao>((resolve, reject): void => {
            apiFile
                .post(`/documentoVersao/finalizarRevisao`, data)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    finalizarAprovacao(finalizarAprovacao: FinalizarAprovacao) {
        return new Promise<DocumentoVersao>((resolve, reject): void => {
            api
                .post(`/documentoVersao/finalizarAprovacao`, JSON.stringify(finalizarAprovacao))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    publicarVersao(publicarVersao: PublicarVersao) {
        return new Promise<DocumentoVersao>((resolve, reject): void => {
            api
                .post(`/documentoVersao/publicar`, JSON.stringify(publicarVersao))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    confirmarLeitura(documentoVersao: DocumentoVersao) {
        return new Promise<DocumentoVersao>((resolve, reject): void => {
            api
                .post(`/documentoVersao/confirmarLeitura`, JSON.stringify(documentoVersao))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    alterarValidade(idVersao: number, novaValidade: Date|null) {
        return new Promise<DocumentoVersao>((resolve, reject): void => {
            api
                .put(`/documentoVersao/alterarValidade`, { idVersao, novaValidade })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
}

export default DocumentoVersaoService;